interface AnimatedValueProps {
  animate?: boolean;
  children: React.ReactNode;
  value: string | number;
}

export const AnimatedValue = ({
  value,
  children,
  animate = true,
}: AnimatedValueProps) => {
  if (!animate) {
    return <div key={`${value}`}>{children}</div>;
  }
  return (
    <div
      key={String(value)}
      className="block w-auto translate-y-0 opacity-100 transition-all duration-300 ease-out"
    >
      <div className="animate-fade-slide-in block w-full translate-y-2 opacity-0">
        {children}
      </div>
      <style>{`
        .animate-fade-slide-in {
          animation: fadeSlideUp 1s cubic-bezier(0.4,0,0.2,1);
          animation-fill-mode: forwards;
        }
        @keyframes fadeSlideUp {
          0% {
            opacity: 0;
            transform: translateY(8px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};
